<app-stages [stages]="stages" currentStage="Informacje podstawowe"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <div class="row">
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"city" as controlName'>
          <label [for]='controlName'>
            Miejscowość *
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu miejscowość'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-md-4'>
        <div class='form-group' *ngIf='"street" as controlName'>
          <label [for]='controlName'>
            Ulica *
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu nazwę ulicy'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <fieldset>
      <legend>
        Działki
      </legend>
      <app-parcels-crud formControlName="parcels">
      </app-parcels-crud>
    </fieldset>
    <div class='application-actions'>
      @if (!uiSettings()?.mobileEmbed) {
        <button
          type='button'
          class='btn btn-secondary'
          (click)='onCancel()'>
        <span>
          Wstecz
        </span>
        </button>
      }
      <button
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
